<div class="portrait-compat">
  <p>{{t 'portraitModeWarning'}}</p>
  <div class="btn btn-secondary" data-close>{{t 'okButton'}}</div>
</div>